import * as React from "react";
import { IBookOfMindState } from "../Helpers/IBookOfMindState";
import { bookOfMindSpeech } from "./BookOfMindSpeech";
import { SpeakItems } from "./Helpers/SpeakItems";

export function BookOfMindSpeechController({
    state,
}: {
    state: IBookOfMindState;
}) {
    React.useEffect(() => {
        if (state.itemsToSpeak.length === 0) {
            return;
        }

        const cancelSpeechItems = SpeakItems(
            state.itemsToSpeak,
            state.spokenQuoteIndex ?? 0
        );

        return () => {
            cancelSpeechItems();
            bookOfMindSpeech.StopPlayback(false);
        };
    }, [state.itemsToSpeak]);

    return null;
}
